import React from 'react';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import R from 'ramda';
import Snackbar from '../../../tc-ui/snack-bar-for-publish.jsx';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const ContractDraftSnackBar = props => {
  const {
    leftNav,
    processing,
    checkContractReadiness,
    draftComplete,
    goToSendUpdates,
    openPublishConfirmation,
    isDummyAccount,
  } = props;
  if (isDummyAccount) return <span/>;
  const isEditedDraft = leftNav.originFrom === 'edited';
  const isContractDraft = isEditedDraft && leftNav.draftType !== 'template';
  const activeDraft = isContractDraft || !isNilOrEmpty(leftNav.sentPartners);
  return (
    <Snackbar
      className="completionCheck"
      bodyStyle={{ maxWidth: '1000px', textAlign: 'center' }}
      open
      onRequestClose={() => {}}
      shouldUpdate={{
        draftComplete,
        activeDraft,
        editHistory: leftNav.editHistory,
      }}
      message={
        <div>
          { activeDraft && !isNilOrEmpty(leftNav.editHistory) ? 'Changes have not been sent to your buyers.' : '' }
          { activeDraft && isNilOrEmpty(leftNav.editHistory) ? `You haven't made any changes yet.` : '' }
          {
            draftComplete ? (
              <FlatButton
                label={activeDraft ? 'Send Updates' : 'Finalise Template'}
                secondary
                disabled={isNilOrEmpty(leftNav.editHistory)}
                loader={processing}
                onTouchTap={activeDraft ? goToSendUpdates : openPublishConfirmation}
                labelStyle={isNilOrEmpty(leftNav.editHistory) ? { color: 'grey' } : { fontWeight: '600' }}
                hoverColor="none"
                style={{ marginLeft: '0' }}
              />
            ) : (
              <FlatButton
                label="Check Your Progress"
                secondary
                loader={processing}
                onTouchTap={() => checkContractReadiness(leftNav.contractId)}
                labelStyle={{ fontWeight: '600' }}
                hoverColor="none"
                style={{ marginLeft: '0' }}
              />
            )
          }
        </div>}
    />
  );
};

export default ContractDraftSnackBar;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/draft-snackbar.jsx